<template>
  <div class="pa-2 sub-topbar-container" ref="topbar">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'SubTopbar',
  mounted () {
    this.$root.$emit('setShift', this.$refs.topbar.clientHeight)
  },
  destroyed () {
    this.$root.$emit('setShift', 0)
  }
}
</script>

<style scoped>
  .sub-topbar-container{
    position: absolute;
    width: 100%;
    height: 52px;
    border-bottom: 1px solid #E5E7E9;
    left: 0%;
    top: 0;
  }
</style>
